import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block"
    >
      <div
        className={`relative overflow-hidden rounded-lg bg-background-100 ${
          isLarge ? 'aspect-[3/4]' : 'aspect-[2/3]'
        }`}
      >
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 韩国漫画`}
          title={`${comic.title} - 51漫画网韩漫推荐`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <p className="text-background-50 text-xs line-clamp-2 leading-relaxed">
            {comic.description}
          </p>
        </div>
        {comic.status === '连载中' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-[10px] font-medium rounded-full whitespace-nowrap">
            连载
          </span>
        )}
        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-50 text-[10px] font-medium rounded-full whitespace-nowrap">
            完结
          </span>
        )}
        <div className="absolute top-2 right-2 px-1.5 py-0.5 bg-black/60 text-background-50 text-[10px] font-medium rounded whitespace-nowrap flex items-center gap-1">
          <i className="ri-star-fill text-accent-400 text-[9px]"></i>
          {comic.rating}
        </div>
      </div>
      <div className="mt-3">
        <h3 className={`font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 whitespace-nowrap ${isLarge ? 'text-base' : 'text-sm'}`}>
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-500 whitespace-nowrap">{comic.author}</span>
          <span className="text-foreground-300 text-[10px]">·</span>
          <span className="text-xs text-foreground-500 whitespace-nowrap">{comic.category}</span>
        </div>
        {!isLarge && (
          <p className="text-xs text-foreground-400 mt-1 line-clamp-1">
            更新至第{comic.totalChapters}话
          </p>
        )}
      </div>
    </Link>
  );
}